import React, {useContext, useState, useRef, useMemo, useEffect} from 'react';
import { makeStyles } from '@material-ui/core/styles';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Link from '@mui/material/Link';
import { Paper, Typography } from "@material-ui/core";
import { LoadingButton } from "@mui/lab";

import {AdminRole} from '../../../model/constants'

import { SummaryTabIndex, MainTabPanelIndex } from '../../../model/constants';
import { AppContext } from '../../../context/app-context';
import { AllEquipsContext } from '../../../context/allEquips-context';
import { UsersContext } from '../../../context/users-context';
import * as EquipWorker from '../../../workers/equipWorker'
import {useSetCurrEquip} from '../../../hooks/useSetCurrEquip'
import ConfirmDlg from '../../dialogs/ConfirmDlg'
import EquipDetailsDlg from '../../dialogs/EquipDetailsDlg'
import { useNavigate } from 'react-router-dom'
import { useExcelDownloder } from "react-xls";
import { parseLocalString } from "../../../utilities/utils";

import {Circle, RadioButtonUnchecked, LocationOnOutlined, Visibility, VisibilityOff, Edit} from "@mui/icons-material"
import TableComponent from '../TableComponent'
import PlayCircleIcon from "@mui/icons-material/PlayCircle";
import StopCircleIcon from "@mui/icons-material/StopCircle";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    gap: 8
    
  },
  commonSpacing:{
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
	},
	paper: {
		display: "flex",
		justifyContent: "flex-start",
		padding: theme.spacing(1),
		gap: theme.spacing(1)
	}
}));

//export default function EquipTable(props) {
const EquipTable = (props) => {
  console.log("render EquipTable");
  const classes = useStyles();

  const [appState, appDispatch] = useContext(AppContext);
  const [usersState, usersDispatch] = useContext(UsersContext);
  const [allEquipsState, allEquipsDispatch] = useContext(AllEquipsContext);
  const setCurrEquip = useSetCurrEquip();
  const [visibleOnly, setVisibleOnly] = useState(true);
  const [activeOnly, setActiveOnly] = useState(false);
  const [filters, setFilters] = React.useState({
    byEquip: '',
    byHospital: '',
    byAddress:''
  });
  const [openConfirm, setOpenConfirm] = React.useState({Open: false, Message: '', Context: undefined});
  const [openEquipDetails, setOpenEquipDetails] = React.useState({Open:false, CurrentEquip: '', Error:false});  
	const [download, setDownload] = React.useState(false);
  const isAdmin = usersState.currentUser?.Role === AdminRole;
	const { ExcelDownloder, Type, setData } = useExcelDownloder();
	const [rows, setRows] = useState([]);
	const tableRef = useRef();
  const columns = [
		{
			field: "IsActive",
			title: "Активен",
			type: "boolean",
			width: 100,
			sorting: true,
			defaultSort: "desc",
			align: "center",
			searchable: false,
			render: (rowData) => (
				<div style={{ color: rowData.IsActive ? "#00ff00" : "gray" }}>
					{rowData.IsActive ? <PlayCircleIcon /> : <StopCircleIcon />}
				</div>
			),
		},
		{ field: "EquipName", title: "Комплекс", width: 150, sorting: true },
		{ field: "AtlasVersion", title: "Версия Atlas", width: 75, sorting: true },
		{ field: "EquipAlias", title: "Алиас", width: 150, sorting: true },
		{
			field: "RegisterDate",
			title: "Дата регистрации",
			type: "datetime",
			dateSetting: { locale: navigator.language },
			width: 200,
			searchable: false,
		},
		{ field: "HospitalName", title: "ЛПУ", sorting: true, editable: "never" },
		{
			field: "HasCoordinates",
			title: "Локация",
			width: 50,
			align: "center",
			type: "boolean",
			searchable: false,
			render: (rowData) => (rowData.HasCoordinates ? <LocationOnOutlined /> : <div />),
		},
		{
			field: "LastSeen",
			title: "Посл. сообщение",
			width: 200,
			type: "datetime",
			dateSetting: { locale: navigator.language },
			sorting: true,
			searchable: false,
		},
		{
			field: "JiraKey",
			title: "Jira",
			width: 100,
			selection: false,
			render: (rowData) => (
				<Link href={rowData.JiraLink?.Link} color="inherit" target="_blank">
					{rowData.JiraKey}
				</Link>
			),
		},
	];
	useEffect(() => {
		if (props.data && JSON.stringify(props.data) !== JSON.stringify(rows)) {
			let result = [...props.data];
			if (activeOnly) {
				result = result?.filter((p) => p.IsActive);
			}
			if (visibleOnly) {
				result = result?.filter((p) => !p.Disabled);
			}
			setRows(result);
		}
	}, [props.data]);

	useEffect(() => {
		if (activeOnly) {
			setRows(prev => prev?.filter(p => p.IsActive))
		} else {
			setRows([...props.data])
		}
	}, [activeOnly])
	
	useEffect(() => {
		if (visibleOnly) {
			setRows((prev) => prev?.filter((p) => !p.Disabled));
		} else {
			setRows([...props.data]);
		}
	}, [visibleOnly]);

  rows.forEach((row) => 
  {
    row.HasCoordinates = row.HospitalLatitude != 0 && row.HospitalLongitude != 0;
    row.JiraKey = row.JiraLink?.Link.split('/').pop();
	});

  const navigate = useNavigate();
  const handleRowClick = async (event, row) => {
    if (event.target.localName === 'a' || event.target.localName === 'input')
      return;

    const equipInfo = row.EquipName;
    setCurrEquip(equipInfo, 'SETEQUIPINFO');
    allEquipsDispatch({ type: 'ADDSELECTEDEQUIPS', payload: equipInfo }); 
    navigate("/info/summary/main", {state: { tabIndex: SummaryTabIndex, panelIndex: MainTabPanelIndex}});
  };

  const onVisibleOnly = async (event) => {
    const value = !visibleOnly;
    setVisibleOnly(value);
    const allEquips = await EquipWorker.GetAllEquips(usersState.token, visibleOnly);
    allEquipsDispatch({ type: 'SETALLEQUIPS', payload: allEquips }); 
  };

  const onActiveOnly = async (event) => {
    const value = !activeOnly;
    setActiveOnly(value);
  };
  
  const onDelete = async (oldData) => {
    const equipInfo = oldData.EquipName;
    await EquipWorker.DeleteEquipInfo(usersState.token, equipInfo);
    const allEquips = await EquipWorker.GetAllEquips(usersState.token, visibleOnly);
    allEquipsDispatch({ type: 'SETALLEQUIPS', payload: allEquips }); 
  };

  const onDisable = (rowData) => {
    setOpenConfirm({Open: true, Message: "Вы действительно хотите " + (rowData.Disabled ? 'показать' : 'скрыть') + " комплекс?", Context: rowData});
  };

  const onConfirmDisable = async (result, context) => {
    setOpenConfirm({...openConfirm, Open: false});
    if (result) {
      const row = context;
      const equipInfo = row.EquipName;
      row.Disabled = !row.Disabled
      await EquipWorker.DisableEquipInfo(usersState.token, equipInfo, row.Disabled);
      allEquipsDispatch({ type: 'UPDATEALLEQUIPS', payload: row });
    }
  };
  
  const onEdit = (equip) => {
    setOpenEquipDetails({Open: true, CurrentEquip: equip});
  };

  const onEquipDetailsClose = async (result, row) => {
    if (result) {
      const equipInfo = row.EquipName;
      let data = await EquipWorker.UpdateEquipDetails(
        usersState.token,
        equipInfo,
        row
      );
      console.log("Data => ", data);
      if (data !== undefined) {
        allEquipsDispatch({ type: "UPDATEALLEQUIPSDETAILS", payload: row });
        setOpenEquipDetails({ Open: false, CurrentEquip: "" });
      } else {
        setOpenEquipDetails({ ...openEquipDetails, Error: true });
      }
    } else {
      setOpenEquipDetails({ Open: false, CurrentEquip: "", Error: false });
    }
	};
	const memoTable = useMemo(
		() => (
			<TableComponent
				columns={columns}
				data={rows}
				// data={[]}
				canEdit={isAdmin}
				onRowClick={handleRowClick}
				onRowDelete={onDelete}
				isDeletable={(rowData) => !rowData.IsActive}
				actions={[
					(rowData) => ({
						icon: () => (rowData.Disabled ? <VisibilityOff /> : <Visibility />),
						tooltip: rowData.Disabled ? "Показать" : "Скрыть",
						onClick: (event, rowData) => onDisable(rowData),
						hidden: !isAdmin,
					}),
					{
						icon: () => <Edit />,
						tooltip: "Редактировать",
						onClick: (event, rowData) => onEdit(rowData),
						hidden: !isAdmin,
					},
				]}
				options={{
					actionsColumnIndex: -1,
				}}
				setData={setData}
				tableRef={tableRef}
			/>
		),
		[rows]
	);

	const equipInfo = props.equipInfo;
	const exportButton = (
		<>
			<LoadingButton
				onClick={() => {
					setDownload((prev) => !prev)
				}}
				loading={download}
				variant="contained"
				color="primary"
				className={classes.commonSpacing}
				disabled={tableRef.current?.state?.data?.length === 0}>
				Выгрузить список комплексов
			</LoadingButton>
			{download ? (
				<>
					<ExcelDownloder
						className="excelDownloadLink"
						data={{
							["комплексы"]: [...(tableRef.current?.state?.data ?? []).map(item => {
								return {
									["Активность"]: item.IsActive ? "Активен" : "Отключен",
									["Комплекс"]: item.EquipName,
									["Версия Atlas"]: item.AtlasVersion,
									["Алиас"]: item.EquipAlias,
									["Дата регистрации"]: parseLocalString(item.RegisterDate),
									["ЛПУ"]: item.HospitalName,
									["Последнее сообщение"]: parseLocalString(item.LastSeen),
								};
						})] }}
						filename={(() => `ComplexList_${parseLocalString(Date.now())}`)()}
						type={Type.Link}>
						<div>Идет формирование файла...</div>
						<div>Пожалуйста, подождите</div>
					</ExcelDownloder>
					<script>
						{setTimeout(() => {
							let link = document.getElementsByClassName("excelDownloadLink")[0];
							if (link) {
								link.click();
							}
							setDownload(false);
						}, 1000)}
					</script>
				</>
			) : (
				<></>
			)}
		</>
	);

  return (
		<div className={classes.root}>
			<div style={{
				position: "sticky",
				top: "80px",
				zIndex: 100,
			}}>
				<Paper className={classes.paper}>
					<FormControlLabel
						control={<Checkbox checked={visibleOnly} onChange={onVisibleOnly} />}
						label="Только нескрытые"
					/>
					<FormControlLabel
						control={<Checkbox checked={activeOnly} onChange={onActiveOnly} />}
						label="Только активные"
					/>
					{exportButton}
				</Paper>
			</div>
			<div className={classes.root}>{memoTable}</div>
			<ConfirmDlg
				open={openConfirm.Open}
				сonfirmMessage={openConfirm.Message}
				onClose={onConfirmDisable}
				context={openConfirm.Context}
			/>
			<EquipDetailsDlg
				open={openEquipDetails.Open}
				onClose={onEquipDetailsClose}
				equip={openEquipDetails.CurrentEquip}
				error={openEquipDetails.Error}
			/>
		</div>
	);
}

export default EquipTable;